import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

import { type ImpersonateValues } from '@/dialogs/ImpersonateDialog.schema';

type StartImpersonationValues = Partial<ImpersonateValues> & {
    target_user_uuid: string;
};

/**
 * Switching identity invalidates everything cached for the previous one
 * (queries, cart context, profile, config), so both directions end in a
 * full reload rather than a selective refetch.
 */
const reloadAsNewIdentity = (queryClient: ReturnType<typeof useQueryClient>) => {
    queryClient.clear();
    window.location.assign('/');
};

export function useStartImpersonation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (values: StartImpersonationValues) => {
            return axios.post('/api/impersonations', values);
        },
        onSuccess: () => {
            reloadAsNewIdentity(queryClient);
        },
    });
}

export function useStopImpersonation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => {
            return axios.post('/api/impersonations/stop');
        },
        onSuccess: () => {
            reloadAsNewIdentity(queryClient);
        },
    });
}
